<template>
  <div>
    <fc-org-select
      ref="org-select"
      v-model="selectIds"
      :companyList="companyList"
      buttonType="button"
      type="user"
      title="人员"
      :disabled="disabled"
      @change="emitInitiator"
    />
  </div>
</template>

<script>
import FormConfig from "../formConfig"; // 表单配置
// 联系人
export default {
  name: "SelectUser",
  props: {
    value: {
      type: [String, Number, Array],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size,
      selectIds: [],
      companyList: workFlowConfig.companyList
    };
  },
  computed: {
    width() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.width || "auto";
      return status;
    },
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    }
  },
  watch: {
    value(val) {
      this.dataModel = val;
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化人员
    init() {
      let companyList = workFlowConfig.companyList;
      let userList = [];
      const formatArray = array => {
        array.forEach(e => {
          if (this.value.includes(e.value)) {
            userList.push(e);
          }
          if (e.children && e.children.length > 0) {
            formatArray(e.children);
          }
        });
      };
      if (this.value && this.value.length > 0) {
        formatArray(companyList);
      }
      this.selectIds = userList;
      console.log(11111, userList);
    },
    // 选择人员
    emitInitiator(data) {
      this.$nextTick(() => {
        this.$emit("input", _.map(data, "value"));
      });
    }
  }
};
</script>
